export var DATE_TYPE = function (DATE_TYPE) {
  DATE_TYPE["YEAR_MONTH_DAY"] = "yyyy-MM-dd";
  DATE_TYPE["EEE_DAY_MONTH_YEAR"] = "EEE dd MMM yyyy";
  DATE_TYPE["E_DAY_MONTH_YEAR"] = "E dd MMM yyyy";
  DATE_TYPE["DD_MM_YYYY"] = "dd/MM/yyyy";
  DATE_TYPE["LLL_DD_Y"] = "LLL dd y";
  DATE_TYPE["D_MMM_YY"] = "dd MMM yy";
  return DATE_TYPE;
}({});